<template>
    <table class="info-table">
        <tbody>
        <tr>
            <th>展台框架：</th>
            <td>采购价：{{configs.params1.zhanjia}}</td>
            <td>,租赁参考价：{{0.4 * configs.params1.zhanjia}}</td>
        </tr>
        <tr>
            <th>展台画面：</th>
            <td>采购价：{{configs.params1.huamian}}</td>
            <td>,租赁参考价：{{configs.params1.huamian}}</td>
        </tr>
        <tr>
            <th>展台配件：</th>
            <td>采购价：{{configs.params1.peijian}}</td>
            <td>,租赁参考价：{{configs.params1.peijian}}</td>
        </tr>
        <tr>
            <th>电器：</th>
            <td>采购价：{{configs.params1.dianqi}}</td>
            <td>,租赁参考价：{{0.4 *configs.params1.dianqi}}</td>
        </tr>
        <tr>
            <th>包装箱：</th>
            <td>采购价：{{configs.params1.baozhuang}}</td>
            <td>,租赁参考价：{{0.5*configs.params1.baozhuang}}</td>
        </tr>
        <tr>
            <th>平面设计费：</th>
            <td>采购价：{{configs.params1.sheji}}</td>
            <td>,租赁参考价：{{configs.params1.sheji}}</td>
        </tr>
        <tr>
            <th>运输费：</th>
            <td>采购价：{{configs.params1.yunshu}}</td>
            <td>,租赁参考价：{{configs.params1.yunshu}}</td>
        </tr>
        <tr>
            <th>器材总价：</th>
            <td>器材采购总价：{{configs.allprice}}</td>
            <td>,器材租赁参考总价：{{configs.allzulingprice}}</td>
        </tr>
        <tr v-if="configs.params2.dajiantype!=3">
            <th>搭建服务：</th>
            <td>搭建尺寸：{{configs.params2.caigouname}}</td>
            <td>搭建价格：{{configs.params2.caigou}}</td>
        </tr>
        <tr>
            <th>订单总价：</th>
            <td>{{price}}</td>

        </tr>
        <tr>
            <th>设计方案下载：</th>
            <td><a class="downloadbtn" :download="file_path" :href="file_path">点击下载</a></td>

        </tr>
        <tr v-if="imgurl_path">
            <th>设计方案预览：</th>
            <td><img class="desimg" :src="imgurl_path" /></td>

        </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    name: "DesTable",
    components: {},
    props: ['configstr',"price","file_path","imgurl_path"],
    data:function() {
        return {
            configs: {},
            jobs:{"11":"优秀设计师","12":"资深设计师","13":"设计总监","14":"顶尖设计师"},
        }
    },
    computed:{
    },
    methods:{
        get_job(index){
            return this.jobs[index];
        },
        get_demandtable(){
            if(this.configstr){
                this.configs=Object.assign({},this.configs,JSON.parse(this.configstr));

            }
            console.log("this.configs1111",this.configs);
        }
    },
    created() {
        this.get_demandtable();
    },
    activated(){

        this.get_demandtable();
console.log(11111111);
    }
}
</script>

<style lang="scss" scoped>
    .desimg{ max-width: 500px;}
    .info-table {
        color: #757575;
        tr {
            height: 30px;
            line-height: 30px;
        }
        .info-div {
         height: 30px;
            line-height: 30px;
        }
    }
    .downloadbtn{ background: red; color: #fff; padding: 5px 10px; line-height: 26px; height: 26px;}
</style>